module.exports = __webpack_public_path__ + "img/st-1.57b6a0ee.png";